// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Common Components - Beautiful Styles
   ============================================ */

/* ============================================
   Back Button
   ============================================ */

.back-button-beautiful {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  background: white;
  border: none;
  border-radius: 12px;
  color: #667eea;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.back-button-beautiful:hover {
  background: #667eea;
  color: white;
  transform: translateX(-5px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.back-button-beautiful i {
  font-size: 18px;
  transition: transform 0.3s ease;
}

.back-button-beautiful:hover i {
  transform: translateX(-3px);
}

/* ============================================
   Loading Spinner
   ============================================ */

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 300px;
}

.loading-container.full-page {
  min-height: 80vh;
}

.loading-content {
  text-align: center;
}

.loading-spinner {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto 25px;
}

.spinner-circle {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 4px solid transparent;
  border-top-color: #667eea;
  animation: spin 1.2s linear infinite;
}

.spinner-circle.delay-1 {
  width: 65px;
  height: 65px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-top-color: #764ba2;
  animation-delay: 0.2s;
}

.spinner-circle.delay-2 {
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-top-color: #f093fb;
  animation-delay: 0.4s;
}

@keyframes spin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}

.spinner-circle:first-child {
  transform: rotate(0deg);
  animation: spin-first 1.2s linear infinite;
}

@keyframes spin-first {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 15px;
}

.loading-dots .dot {
  width: 10px;
  height: 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  animation: bounce 1.4s ease-in-out infinite;
}

.loading-dots .dot:nth-child(1) { animation-delay: 0s; }
.loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }
.loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.loading-message {
  color: #666;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
}

/* ============================================
   No Data Found
   ============================================ */

.no-data-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 400px;
}

.no-data-content {
  text-align: center;
  max-width: 400px;
}

.no-data-illustration {
  position: relative;
  width: 180px;
  height: 180px;
  margin: 0 auto 30px;
}

.illustration-circle {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #f0f4ff 0%, #e8ecff 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.illustration-inner {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
}

.illustration-inner i {
  font-size: 45px;
  color: white;
}

.floating-elements {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.float-element {
  position: absolute;
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  animation: floatAround 4s ease-in-out infinite;
}

.float-element i {
  font-size: 18px;
  color: #667eea;
}

.float-element.el-1 {
  top: 0;
  right: 10px;
  animation-delay: 0s;
}

.float-element.el-2 {
  bottom: 20px;
  left: 0;
  animation-delay: 1s;
}

.float-element.el-3 {
  bottom: 0;
  right: 0;
  animation-delay: 2s;
}

@keyframes floatAround {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-10px) rotate(5deg); }
  50% { transform: translateY(0) rotate(0deg); }
  75% { transform: translateY(10px) rotate(-5deg); }
}

.no-data-title {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
}

.no-data-message {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 25px;
}

.no-data-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

.no-data-back-btn {
  padding: 12px 30px;
  border-radius: 12px;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  transition: all 0.3s ease;
}

.no-data-back-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

/* ============================================
   Page Header with Back Button
   ============================================ */

.page-header-beautiful {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  padding: 20px 25px;
  margin-bottom: 25px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  flex-wrap: wrap;
  gap: 15px;
}

.page-header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.header-back-btn {
  width: 45px;
  height: 45px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.header-back-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateX(-3px);
}

.page-header-icon {
  width: 55px;
  height: 55px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-header-icon i {
  font-size: 26px;
  color: white;
}

.page-header-text h2 {
  color: white;
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 4px 0;
}

.page-header-text p {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  margin: 0;
}

.page-header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.page-header-count {
  background: white;
  border-radius: 15px;
  padding: 12px 22px;
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.page-header-count .count-number {
  display: block;
  font-size: 28px;
  font-weight: 700;
  color: #667eea;
  line-height: 1;
}

.page-header-count .count-label {
  font-size: 11px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* ============================================
   Skeleton Loader
   ============================================ */

.skeleton-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
  padding: 10px 0;
}

.skeleton-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
}

.skeleton-header {
  height: 100px;
  background: #e9ecef;
}

.skeleton-body {
  padding: 15px;
}

.skeleton-title {
  height: 18px;
  background: #e9ecef;
  border-radius: 4px;
  margin-bottom: 12px;
  width: 80%;
}

.skeleton-text {
  height: 12px;
  background: #e9ecef;
  border-radius: 4px;
  margin-bottom: 15px;
  width: 60%;
}

.skeleton-button {
  height: 35px;
  background: #e9ecef;
  border-radius: 8px;
}

.shimmer {
  background: linear-gradient(90deg, #e9ecef 25%, #f8f9fa 50%, #e9ecef 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ============================================
   Responsive Styles
   ============================================ */

@media (max-width: 767.98px) {
  .page-header-beautiful {
    flex-direction: column;
    text-align: center;
    padding: 15px 20px;
  }

  .page-header-left {
    flex-direction: column;
  }

  .header-back-btn {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }

  .page-header-icon {
    width: 50px;
    height: 50px;
  }

  .page-header-icon i {
    font-size: 22px;
  }

  .page-header-text h2 {
    font-size: 18px;
  }

  .page-header-text p {
    font-size: 12px;
  }

  .page-header-count {
    width: 100%;
    padding: 10px 15px;
  }

  .page-header-count .count-number {
    font-size: 24px;
  }

  .no-data-illustration {
    width: 150px;
    height: 150px;
  }

  .illustration-circle {
    width: 120px;
    height: 120px;
  }

  .illustration-inner {
    width: 80px;
    height: 80px;
  }

  .illustration-inner i {
    font-size: 35px;
  }

  .float-element {
    width: 35px;
    height: 35px;
  }

  .float-element i {
    font-size: 14px;
  }

  .no-data-title {
    font-size: 20px;
  }

  .no-data-message {
    font-size: 14px;
  }

  .loading-spinner {
    width: 60px;
    height: 60px;
  }

  .spinner-circle.delay-1 {
    width: 50px;
    height: 50px;
  }

  .spinner-circle.delay-2 {
    width: 38px;
    height: 38px;
  }

  .skeleton-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}

@media (max-width: 575.98px) {
  .back-button-beautiful {
    padding: 8px 16px;
    font-size: 13px;
  }

  .skeleton-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .skeleton-header {
    height: 80px;
  }
}

/* ============================================
   Student AI Module
   ============================================ */

.student-ai-page {
  padding: 20px;
  min-height: 100vh;
  background: linear-gradient(160deg, #f0f4ff 0%, #e8ecff 50%, #faf5ff 100%);
}

.student-ai-container {
  max-width: 900px;
  margin: 0 auto;
  padding-top: 24px;
}

.student-ai-form-card {
  border: none;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(99, 102, 241, 0.12);
  overflow: hidden;
  margin-bottom: 24px;
  background: #fff;
}

.student-ai-form-card .card-body {
  padding: 28px 32px;
}

.student-ai-form-title {
  color: #3730a3;
  font-weight: 700;
  margin-bottom: 22px;
  font-size: 1.15rem;
}

.student-ai-select {
  border-radius: 12px;
  border: 1px solid #e0e7ff;
  padding: 10px 14px;
  font-size: 0.95rem;
}

.student-ai-select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

.student-ai-query-input {
  border-radius: 12px;
  border: 1px solid #e0e7ff;
  padding: 12px 16px;
  font-size: 1rem;
}

.student-ai-query-input:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

.student-ai-file-input {
  border-radius: 12px;
  border: 1px solid #e0e7ff;
  padding: 10px 14px;
  font-size: 0.9rem;
}

.student-ai-file-hint {
  font-size: 0.875rem;
  color: #64748b;
}

.student-ai-search-btn {
  border-radius: 12px;
  padding: 12px 28px;
  font-weight: 600;
  font-size: 1rem;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border: none;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4);
  transition: transform 0.2s, box-shadow 0.2s;
}

.student-ai-search-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
}

.student-ai-search-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.student-ai-error {
  padding: 12px 16px;
  border-radius: 12px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
}

.student-ai-response-card {
  border: none;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(99, 102, 241, 0.12);
  overflow: hidden;
  background: #fff;
  animation: studentAiFadeIn 0.4s ease;
}

@keyframes studentAiFadeIn {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.student-ai-response-card .card-body {
  padding: 28px 32px;
}

.student-ai-response-title {
  color: #3730a3;
  font-weight: 700;
  margin-bottom: 18px;
  font-size: 1.15rem;
}

.student-ai-response-body {
  color: #374151;
  font-size: 1rem;
  line-height: 1.65;
}

.student-ai-answer {
  background: #f8fafc;
  border-radius: 12px;
  padding: 18px 20px;
  border-left: 4px solid #6366f1;
}

.student-ai-answer p {
  white-space: pre-wrap;
  word-break: break-word;
}

.student-ai-pre {
  margin: 0;
  font-size: 0.9rem;
  white-space: pre-wrap;
  word-break: break-word;
  background: transparent;
  border: none;
  padding: 0;
}

@media (max-width: 768px) {
  .student-ai-form-card .card-body,
  .student-ai-response-card .card-body {
    padding: 20px 20px;
  }

  .student-ai-container {
    padding-top: 16px;
  }
}

/* ============================================
   Student AI - Dark theme (AI Teacher style)
   ============================================ */

.student-ai-wrap.student-ai-dark {
  display: flex;
  min-height: 85vh;
  height: 85vh;
  background: #1a1b23;
  color: #e2e8f0;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
}

.student-ai-wrap.student-ai-dark.student-ai-loading {
  display: block;
}

.student-ai-wrap.student-ai-dark.student-ai-loading .loading-container.full-page {
  min-height: 100%;
  height: 100%;
  width: 100%;
  padding: 20px;
}

.student-ai-sidebar {
  width: 280px;
  min-width: 280px;
  background: #16171f;
  border-right: 1px solid #2d2e3a;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
}

.student-ai-back {
  background: transparent;
  border: none;
  color: #94a3b8;
  font-size: 13px;
  padding: 8px 0;
  margin-bottom: 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: color 0.2s;
}

.student-ai-back:hover {
  color: #e2e8f0;
}

.student-ai-brand {
  margin-bottom: 24px;
}

.student-ai-brand-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #38bdf8, #22d3ee);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.student-ai-brand-icon i {
  font-size: 24px;
  color: #fff;
}

.student-ai-brand-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #f1f5f9;
  margin: 0 0 4px 0;
}

.student-ai-brand-sub {
  font-size: 0.7rem;
  color: #64748b;
  margin: 0;
  letter-spacing: 0.08em;
}

.student-ai-new-btn {
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.9rem;
  border: none;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #fff;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s, transform 0.2s;
}

.student-ai-new-btn:hover {
  opacity: 0.95;
  transform: translateY(-1px);
  color: #fff;
}

.student-ai-recent {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.student-ai-recent-title {
  font-size: 0.7rem;
  color: #64748b;
  margin: 0 0 12px 0;
  letter-spacing: 0.08em;
}

.student-ai-recent-list {
  list-style: none;
  padding: 0;
  margin: 0;
  overflow-y: auto;
}

.student-ai-recent-empty {
  font-size: 0.85rem;
  color: #64748b;
  padding: 8px 0;
}

.student-ai-recent-item {
  font-size: 0.85rem;
  color: #94a3b8;
  padding: 10px 12px;
  border-radius: 10px;
  margin-bottom: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.student-ai-recent-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.student-ai-recent-item.is-active {
  background: rgba(59, 130, 246, 0.22);
  color: #dbeafe;
}

.student-ai-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.student-ai-top {
  padding: 8px 16px;
  background: #1a1b23;
  position: sticky;
  top: 0;
  z-index: 10;
}

.student-ai-top-card {
  background: #111321;
  border-radius: 14px;
  border: 1px solid #2d2e3a;
  padding: 10px 12px;
}

.student-ai-context-prompt {
  font-size: 0.8rem;
  color: #94a3b8;
  margin: 0 0 14px 0;
}

.student-ai-dropdowns {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin: 0;
}

.student-ai-dropdown-group {
  flex: 1 1;
  min-width: 140px;
}

.student-ai-dropdown-group label {
  display: block;
  font-size: 0.7rem;
  color: #64748b;
  margin-bottom: 6px;
  letter-spacing: 0.05em;
}

.student-ai-react-select {
  width: 100%;
}

.student-ai-react-select .student-ai-select__control {
  border-radius: 10px;
  border: 1px solid #2d2e3a;
  background: #25262f;
  min-height: 40px;
  box-shadow: none;
}

.student-ai-react-select .student-ai-select__control--is-focused {
  border-color: #6366f1;
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.25);
}

.student-ai-react-select .student-ai-select__value-container {
  padding: 4px 8px;
  color: #e2e8f0;
}

.student-ai-react-select .student-ai-select__indicator-separator {
  display: none;
}

.student-ai-react-select .student-ai-select__single-value {
  color: #e2e8f0;
  font-size: 0.9rem;
}

.student-ai-react-select .student-ai-select__placeholder {
  color: #e2e8f0;
  font-size: 0.9rem;
}

.student-ai-react-select .student-ai-select__input-container {
  color: #ffffff;
}

/* Ensure typed search text inside react-select is white */
.student-ai-react-select .student-ai-select__input input {
  color: #ffffff;
}

.student-ai-react-select .student-ai-select__menu {
  background: #181922;
  border-radius: 10px;
  border: 1px solid #2d2e3a;
  z-index: 20;
}

.student-ai-react-select .student-ai-select__option {
  font-size: 0.9rem;
  padding: 8px 10px;
  cursor: pointer;
}

.student-ai-react-select .student-ai-select__option--is-focused {
  background: rgba(99, 102, 241, 0.2);
}

.student-ai-react-select .student-ai-select__option--is-selected {
  background: #6366f1;
  color: #fff;
}

.student-ai-image-group {
  min-width: 180px;
}

.student-ai-top-image-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
}

.student-ai-top-image-btn {
  flex: 1 1;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #2d2e3a;
  background: #25262f;
  color: #94a3b8;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: border-color 0.2s, color 0.2s;
  margin: 0;
}

.student-ai-top-image-btn:hover {
  border-color: #38bdf8;
  color: #e2e8f0;
}

.student-ai-top-image-btn i {
  font-size: 1.1rem;
  color: #64748b;
}

.student-ai-top-image-btn span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 140px;
}

.student-ai-top-image-remove {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #2d2e3a;
  background: #25262f;
  color: #94a3b8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: color 0.2s, background 0.2s;
}

.student-ai-top-image-remove:hover {
  color: #f87171;
  background: rgba(248, 113, 113, 0.1);
}

.student-ai-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.student-ai-tag {
  font-size: 0.8rem;
  padding: 6px 12px;
  border-radius: 8px;
  background: #25262f;
  color: #94a3b8;
  border: 1px solid #2d2e3a;
}

.student-ai-content {
  flex: 1 1;
  padding: 28px 28px 24px;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.student-ai-welcome {
  max-width: 480px;
  margin: 0 auto;
  text-align: center;
  padding: 40px 20px;
}

.student-ai-welcome-icon {
  width: 88px;
  height: 88px;
  border-radius: 20px;
  background: linear-gradient(135deg, #38bdf8, #22d3ee);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.student-ai-welcome-icon i {
  font-size: 44px;
  color: #fff;
}

.student-ai-welcome-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #f1f5f9;
  margin: 0 0 12px 0;
}

.student-ai-welcome-desc {
  font-size: 1rem;
  color: #94a3b8;
  line-height: 1.6;
  margin: 0;
}

.student-ai-chat {
  margin-bottom: 20px;
}

.student-ai-msg {
  max-width: 85%;
  margin-bottom: 12px;
}

.student-ai-msg-user {
  margin-left: auto;
}

.student-ai-msg-ai {
  margin-right: auto;
}

.student-ai-msg-label {
  font-size: 0.75rem;
  color: #64748b;
  margin-bottom: 4px;
  display: block;
}

.student-ai-msg-label-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.student-ai-voice-btn {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1px solid #3f4150;
  background: #25262f;
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s, transform 0.2s;
}

.student-ai-voice-btn:hover {
  color: #38bdf8;
  border-color: rgba(56, 189, 248, 0.5);
  transform: translateY(-1px);
}

.student-ai-voice-btn.is-speaking {
  color: #22d3ee;
  border-color: #22d3ee;
}

.student-ai-msg-user .student-ai-msg-text {
  background: #25262f;
  border: 1px solid #2d2e3a;
  color: #e2e8f0;
  padding: 14px 18px;
  border-radius: 14px 14px 14px 4px;
  margin: 0;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
}

.student-ai-msg-ai .student-ai-msg-text {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(139, 92, 246, 0.15));
  border: 1px solid rgba(99, 102, 241, 0.3);
  color: #e2e8f0;
  padding: 0;
  border-radius: 14px 14px 4px 14px;
  margin: 0;
}

.student-ai-answer-box {
  padding: 14px 18px;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
}

.student-ai-answer-line {
  margin: 0 0 6px 0;
  font-size: 0.95rem;
}

.student-ai-answer-line:last-child {
  margin-bottom: 0;
}

.student-ai-msg-typing .student-ai-dots {
  display: flex;
  gap: 6px;
  padding: 14px 18px;
}

.student-ai-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #64748b;
  animation: studentAiBounce 1.4s ease-in-out infinite both;
}

.student-ai-dots span:nth-child(1) { animation-delay: 0s; }
.student-ai-dots span:nth-child(2) { animation-delay: 0.2s; }
.student-ai-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes studentAiBounce {
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.5; }
  40% { transform: scale(1); opacity: 1; }
}

.student-ai-error-bar {
  padding: 10px 28px;
  background: rgba(239, 68, 68, 0.15);
  color: #fca5a5;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
}

.student-ai-input-bar {
  padding: 16px 28px 24px;
  border-top: 1px solid #2d2e3a;
  background: #1a1b23;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.student-ai-input-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #25262f;
  border: 1px solid #2d2e3a;
  border-radius: 14px;
  padding: 8px 12px 8px 18px;
  min-width: 0;
}

.student-ai-input-wrap.is-drag-over {
  border-color: #38bdf8;
  background: rgba(56, 189, 248, 0.08);
}

.student-ai-input {
  flex: 1 1;
  min-width: 0;
  background: transparent;
  border: none;
  color: #e2e8f0;
  font-size: 0.95rem;
  padding: 10px 0;
  outline: none;
}

.student-ai-input::placeholder {
  color: #64748b;
}

.student-ai-file-hidden {
  display: none;
}

.student-ai-attach-btn {
  flex-shrink: 0;
  padding: 8px 14px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #94a3b8;
  cursor: pointer;
  border: 1px dashed #3f4150;
  transition: color 0.2s, background 0.2s, border-color 0.2s;
}

.student-ai-attach-btn:hover {
  color: #38bdf8;
  background: rgba(56, 189, 248, 0.1);
  border-color: rgba(56, 189, 248, 0.4);
}

.student-ai-attach-btn i {
  font-size: 1.2rem;
}

.student-ai-attach-label {
  font-size: 0.85rem;
  font-weight: 500;
}

.student-ai-send-btn {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  padding: 0;
  border: none;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s, transform 0.2s;
}

.student-ai-send-btn:hover:not(:disabled) {
  opacity: 0.95;
  transform: scale(1.05);
  color: #fff;
}

.student-ai-send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.student-ai-send-btn i {
  font-size: 1.25rem;
}

.student-ai-mic-btn {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: 1px solid #3f4150;
  background: #1f2029;
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s, background 0.2s, transform 0.2s;
}

.student-ai-mic-btn:hover {
  color: #38bdf8;
  border-color: rgba(56, 189, 248, 0.5);
  transform: scale(1.03);
}

.student-ai-mic-btn.is-listening {
  color: #22d3ee;
  border-color: #22d3ee;
  background: rgba(34, 211, 238, 0.12);
  animation: studentAiMicPulse 1.1s ease-in-out infinite;
}

@keyframes studentAiMicPulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(34, 211, 238, 0.35); }
  50% { box-shadow: 0 0 0 8px rgba(34, 211, 238, 0); }
}

.student-ai-file-hint-bar {
  font-size: 0.8rem;
  color: #94a3b8;
  margin-top: 8px;
  display: flex;
  align-items: center;
}

.student-ai-file-remove {
  margin-left: 10px;
  background: none;
  border: none;
  color: #f87171;
  cursor: pointer;
  font-size: 0.8rem;
}

.student-ai-file-remove:hover {
  text-decoration: underline;
}

.student-ai-disclaimer {
  font-size: 0.75rem;
  color: #64748b;
  margin: 10px 0 0 0;
}

/* Student AI - Tablet and below */
@media (max-width: 768px) {
  .student-ai-wrap.student-ai-dark {
    flex-direction: column;
    min-height: 100vh;
    min-height: 100dvh;
  }

  .student-ai-sidebar {
    width: 100%;
    min-width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    padding: 12px 14px;
    border-bottom: 1px solid #2d2e3a;
  }

  .student-ai-back {
    order: 0;
    margin: 0;
    padding: 8px 0;
    min-height: 44px;
    display: inline-flex;
    align-items: center;
  }

  .student-ai-brand {
    order: 1;
    margin: 0 auto 0 0;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 0;
  }

  .student-ai-brand-icon {
    width: 36px;
    height: 36px;
    margin: 0;
  }

  .student-ai-brand-icon i {
    font-size: 18px;
  }

  .student-ai-brand-title {
    font-size: 1.1rem;
  }

  .student-ai-new-btn {
    order: 2;
    width: auto;
    margin: 0;
    padding: 10px 16px;
    font-size: 0.85rem;
    min-height: 44px;
  }

  .student-ai-recent {
    order: 3;
    width: 100%;
    max-height: 100px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .student-ai-recent-title {
    margin-bottom: 8px;
  }

  .student-ai-recent-item {
    padding: 8px 10px;
    font-size: 0.8rem;
  }

  .student-ai-top {
    padding: 12px 14px;
    flex-shrink: 0;
  }

  .student-ai-dropdowns {
    gap: 12px;
    flex-direction: column;
  }

  .student-ai-dropdown-group {
    min-width: 100%;
    width: 100%;
  }

  .student-ai-dropdown-group label {
    font-size: 0.65rem;
  }

  .student-ai-select-dark {
    padding: 12px 14px;
    font-size: 1rem;
    min-height: 48px;
  }

  .student-ai-image-group {
    min-width: 100%;
    width: 100%;
  }

  .student-ai-top-image-wrap {
    min-height: 48px;
  }

  .student-ai-top-image-btn {
    padding: 12px 14px;
    font-size: 0.95rem;
    min-height: 48px;
  }

  .student-ai-top-image-btn span {
    max-width: 100%;
  }

  .student-ai-top-image-remove {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
  }

  .student-ai-content {
    padding: 14px 14px 12px;
    flex: 1 1;
  }

  .student-ai-welcome {
    padding: 20px 12px;
    max-width: 100%;
  }

  .student-ai-welcome-icon {
    width: 72px;
    height: 72px;
    margin-bottom: 20px;
  }

  .student-ai-welcome-icon i {
    font-size: 36px;
  }

  .student-ai-welcome-title {
    font-size: 1.35rem;
  }

  .student-ai-welcome-desc {
    font-size: 0.95rem;
  }

  .student-ai-msg {
    max-width: 92%;
  }

  .student-ai-msg-user .student-ai-msg-text,
  .student-ai-msg-ai .student-ai-msg-text {
    padding: 12px 14px;
    font-size: 0.95rem;
  }

  .student-ai-error-bar {
    padding: 10px 14px;
    font-size: 0.8rem;
  }

  .student-ai-input-bar {
    padding: 12px 14px 20px;
    padding-bottom: max(20px, env(safe-area-inset-bottom));
    flex-shrink: 0;
    overflow: hidden;
  }

  .student-ai-input-wrap {
    padding: 8px 10px 8px 14px;
    gap: 8px;
    min-height: 52px;
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
  }

  .student-ai-input {
    font-size: 16px;
    min-height: 20px;
  }

  .student-ai-attach-btn {
    padding: 10px 12px;
    min-height: 44px;
    flex-shrink: 0;
  }

  .student-ai-attach-label {
    font-size: 0.8rem;
  }

  .student-ai-send-btn {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
  }

  .student-ai-mic-btn {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
  }

  .student-ai-disclaimer {
    font-size: 0.7rem;
    margin-top: 8px;
  }
}

/* Student AI - Small phones */
@media (max-width: 480px) {
  .student-ai-sidebar {
    padding: 10px 12px;
    gap: 8px;
  }

  .student-ai-brand-title {
    font-size: 1rem;
  }

  .student-ai-brand-sub {
    font-size: 0.65rem;
  }

  .student-ai-new-btn {
    padding: 8px 12px;
    font-size: 0.8rem;
  }

  .student-ai-recent {
    max-height: 80px;
  }

  .student-ai-top {
    padding: 10px 12px;
  }

  .student-ai-select-dark {
    padding: 10px 12px;
    min-height: 44px;
  }

  .student-ai-top-image-btn {
    padding: 10px 12px;
    min-height: 44px;
  }

  .student-ai-top-image-btn span {
    font-size: 0.85rem;
  }

  .student-ai-content {
    padding: 12px 12px 10px;
  }

  .student-ai-welcome {
    padding: 16px 10px;
  }

  .student-ai-welcome-icon {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
  }

  .student-ai-welcome-icon i {
    font-size: 32px;
  }

  .student-ai-welcome-title {
    font-size: 1.2rem;
  }

  .student-ai-welcome-desc {
    font-size: 0.9rem;
  }

  .student-ai-input-bar {
    padding: 10px 12px 16px;
    padding-bottom: max(16px, env(safe-area-inset-bottom));
  }

  .student-ai-input-wrap {
    padding: 6px 8px 6px 12px;
    min-height: 48px;
    min-width: 0;
  }

  .student-ai-attach-btn .student-ai-attach-label {
    display: none;
  }

  .student-ai-attach-btn {
    padding: 10px;
    min-width: 44px;
  }

  .student-ai-send-btn {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
  }

  .student-ai-mic-btn {
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
  }

  .student-ai-msg-user .student-ai-msg-text,
  .student-ai-msg-ai .student-ai-msg-text {
    padding: 10px 12px;
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/dashboards/components/common-components.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;;iDAEiD;;AAEjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,KAAK,6CAA6C,EAAE;EACpD,OAAO,+CAA+C,EAAE;AAC1D;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,kCAAkC,mBAAmB,EAAE;AACvD,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,qBAAqB,EAAE;;AAEzD;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,yCAAyC,EAAE;EACjD,MAAM,qCAAqC,EAAE;EAC7C,MAAM,yCAAyC,EAAE;AACnD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,iBAAiB;EACjB,0EAA0E;AAC5E;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yCAAyC;EACzC,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sFAAsF;EACtF,yCAAyC;EACzC,cAAc;EACd,UAAU;EACV,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA,qCAAqC,mBAAmB,EAAE;AAC1D,qCAAqC,qBAAqB,EAAE;AAC5D,qCAAqC,qBAAqB,EAAE;;AAE5D;EACE,gBAAgB,qBAAqB,EAAE,YAAY,EAAE;EACrD,MAAM,mBAAmB,EAAE,UAAU,EAAE;AACzC;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,WAAW,4CAA4C,EAAE;EACzD,MAAM,2CAA2C,EAAE;AACrD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE;IACE,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,SAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,sDAAsD;IACtD,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,sDAAsD;EACxD;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":["/* ============================================\n   Common Components - Beautiful Styles\n   ============================================ */\n\n/* ============================================\n   Back Button\n   ============================================ */\n\n.back-button-beautiful {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 20px;\n  background: white;\n  border: none;\n  border-radius: 12px;\n  color: #667eea;\n  font-weight: 600;\n  font-size: 14px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  margin-bottom: 20px;\n}\n\n.back-button-beautiful:hover {\n  background: #667eea;\n  color: white;\n  transform: translateX(-5px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.back-button-beautiful i {\n  font-size: 18px;\n  transition: transform 0.3s ease;\n}\n\n.back-button-beautiful:hover i {\n  transform: translateX(-3px);\n}\n\n/* ============================================\n   Loading Spinner\n   ============================================ */\n\n.loading-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  min-height: 300px;\n}\n\n.loading-container.full-page {\n  min-height: 80vh;\n}\n\n.loading-content {\n  text-align: center;\n}\n\n.loading-spinner {\n  position: relative;\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 25px;\n}\n\n.spinner-circle {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 4px solid transparent;\n  border-top-color: #667eea;\n  animation: spin 1.2s linear infinite;\n}\n\n.spinner-circle.delay-1 {\n  width: 65px;\n  height: 65px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-top-color: #764ba2;\n  animation-delay: 0.2s;\n}\n\n.spinner-circle.delay-2 {\n  width: 50px;\n  height: 50px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-top-color: #f093fb;\n  animation-delay: 0.4s;\n}\n\n@keyframes spin {\n  0% { transform: translate(-50%, -50%) rotate(0deg); }\n  100% { transform: translate(-50%, -50%) rotate(360deg); }\n}\n\n.spinner-circle:first-child {\n  transform: rotate(0deg);\n  animation: spin-first 1.2s linear infinite;\n}\n\n@keyframes spin-first {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-dots {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 15px;\n}\n\n.loading-dots .dot {\n  width: 10px;\n  height: 10px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 50%;\n  animation: bounce 1.4s ease-in-out infinite;\n}\n\n.loading-dots .dot:nth-child(1) { animation-delay: 0s; }\n.loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }\n.loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }\n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(0.6);\n    opacity: 0.5;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.loading-message {\n  color: #666;\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0;\n}\n\n/* ============================================\n   No Data Found\n   ============================================ */\n\n.no-data-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  min-height: 400px;\n}\n\n.no-data-content {\n  text-align: center;\n  max-width: 400px;\n}\n\n.no-data-illustration {\n  position: relative;\n  width: 180px;\n  height: 180px;\n  margin: 0 auto 30px;\n}\n\n.illustration-circle {\n  width: 150px;\n  height: 150px;\n  background: linear-gradient(135deg, #f0f4ff 0%, #e8ecff 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  position: relative;\n  animation: float 3s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-10px); }\n}\n\n.illustration-inner {\n  width: 100px;\n  height: 100px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);\n}\n\n.illustration-inner i {\n  font-size: 45px;\n  color: white;\n}\n\n.floating-elements {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n\n.float-element {\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  background: white;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);\n  animation: floatAround 4s ease-in-out infinite;\n}\n\n.float-element i {\n  font-size: 18px;\n  color: #667eea;\n}\n\n.float-element.el-1 {\n  top: 0;\n  right: 10px;\n  animation-delay: 0s;\n}\n\n.float-element.el-2 {\n  bottom: 20px;\n  left: 0;\n  animation-delay: 1s;\n}\n\n.float-element.el-3 {\n  bottom: 0;\n  right: 0;\n  animation-delay: 2s;\n}\n\n@keyframes floatAround {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  25% { transform: translateY(-10px) rotate(5deg); }\n  50% { transform: translateY(0) rotate(0deg); }\n  75% { transform: translateY(10px) rotate(-5deg); }\n}\n\n.no-data-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 12px;\n}\n\n.no-data-message {\n  font-size: 15px;\n  color: #666;\n  line-height: 1.6;\n  margin-bottom: 25px;\n}\n\n.no-data-actions {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n.no-data-back-btn {\n  padding: 12px 30px;\n  border-radius: 12px;\n  font-weight: 600;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border: none;\n  transition: all 0.3s ease;\n}\n\n.no-data-back-btn:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n/* ============================================\n   Page Header with Back Button\n   ============================================ */\n\n.page-header-beautiful {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 20px;\n  padding: 20px 25px;\n  margin-bottom: 25px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.page-header-left {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.header-back-btn {\n  width: 45px;\n  height: 45px;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 12px;\n  color: white;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.header-back-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateX(-3px);\n}\n\n.page-header-icon {\n  width: 55px;\n  height: 55px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.page-header-icon i {\n  font-size: 26px;\n  color: white;\n}\n\n.page-header-text h2 {\n  color: white;\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0 0 4px 0;\n}\n\n.page-header-text p {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 13px;\n  margin: 0;\n}\n\n.page-header-right {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.page-header-count {\n  background: white;\n  border-radius: 15px;\n  padding: 12px 22px;\n  text-align: center;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);\n}\n\n.page-header-count .count-number {\n  display: block;\n  font-size: 28px;\n  font-weight: 700;\n  color: #667eea;\n  line-height: 1;\n}\n\n.page-header-count .count-label {\n  font-size: 11px;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n/* ============================================\n   Skeleton Loader\n   ============================================ */\n\n.skeleton-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 20px;\n  padding: 10px 0;\n}\n\n.skeleton-card {\n  background: white;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n}\n\n.skeleton-header {\n  height: 100px;\n  background: #e9ecef;\n}\n\n.skeleton-body {\n  padding: 15px;\n}\n\n.skeleton-title {\n  height: 18px;\n  background: #e9ecef;\n  border-radius: 4px;\n  margin-bottom: 12px;\n  width: 80%;\n}\n\n.skeleton-text {\n  height: 12px;\n  background: #e9ecef;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  width: 60%;\n}\n\n.skeleton-button {\n  height: 35px;\n  background: #e9ecef;\n  border-radius: 8px;\n}\n\n.shimmer {\n  background: linear-gradient(90deg, #e9ecef 25%, #f8f9fa 50%, #e9ecef 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ============================================\n   Responsive Styles\n   ============================================ */\n\n@media (max-width: 767.98px) {\n  .page-header-beautiful {\n    flex-direction: column;\n    text-align: center;\n    padding: 15px 20px;\n  }\n\n  .page-header-left {\n    flex-direction: column;\n  }\n\n  .header-back-btn {\n    width: 40px;\n    height: 40px;\n    font-size: 18px;\n  }\n\n  .page-header-icon {\n    width: 50px;\n    height: 50px;\n  }\n\n  .page-header-icon i {\n    font-size: 22px;\n  }\n\n  .page-header-text h2 {\n    font-size: 18px;\n  }\n\n  .page-header-text p {\n    font-size: 12px;\n  }\n\n  .page-header-count {\n    width: 100%;\n    padding: 10px 15px;\n  }\n\n  .page-header-count .count-number {\n    font-size: 24px;\n  }\n\n  .no-data-illustration {\n    width: 150px;\n    height: 150px;\n  }\n\n  .illustration-circle {\n    width: 120px;\n    height: 120px;\n  }\n\n  .illustration-inner {\n    width: 80px;\n    height: 80px;\n  }\n\n  .illustration-inner i {\n    font-size: 35px;\n  }\n\n  .float-element {\n    width: 35px;\n    height: 35px;\n  }\n\n  .float-element i {\n    font-size: 14px;\n  }\n\n  .no-data-title {\n    font-size: 20px;\n  }\n\n  .no-data-message {\n    font-size: 14px;\n  }\n\n  .loading-spinner {\n    width: 60px;\n    height: 60px;\n  }\n\n  .spinner-circle.delay-1 {\n    width: 50px;\n    height: 50px;\n  }\n\n  .spinner-circle.delay-2 {\n    width: 38px;\n    height: 38px;\n  }\n\n  .skeleton-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .back-button-beautiful {\n    padding: 8px 16px;\n    font-size: 13px;\n  }\n\n  .skeleton-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .skeleton-header {\n    height: 80px;\n  }\n}\n\n/* ============================================\n   Student AI Module\n   ============================================ */\n\n.student-ai-page {\n  padding: 20px;\n  min-height: 100vh;\n  background: linear-gradient(160deg, #f0f4ff 0%, #e8ecff 50%, #faf5ff 100%);\n}\n\n.student-ai-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding-top: 24px;\n}\n\n.student-ai-form-card {\n  border: none;\n  border-radius: 20px;\n  box-shadow: 0 10px 40px rgba(99, 102, 241, 0.12);\n  overflow: hidden;\n  margin-bottom: 24px;\n  background: #fff;\n}\n\n.student-ai-form-card .card-body {\n  padding: 28px 32px;\n}\n\n.student-ai-form-title {\n  color: #3730a3;\n  font-weight: 700;\n  margin-bottom: 22px;\n  font-size: 1.15rem;\n}\n\n.student-ai-select {\n  border-radius: 12px;\n  border: 1px solid #e0e7ff;\n  padding: 10px 14px;\n  font-size: 0.95rem;\n}\n\n.student-ai-select:focus {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n}\n\n.student-ai-query-input {\n  border-radius: 12px;\n  border: 1px solid #e0e7ff;\n  padding: 12px 16px;\n  font-size: 1rem;\n}\n\n.student-ai-query-input:focus {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n}\n\n.student-ai-file-input {\n  border-radius: 12px;\n  border: 1px solid #e0e7ff;\n  padding: 10px 14px;\n  font-size: 0.9rem;\n}\n\n.student-ai-file-hint {\n  font-size: 0.875rem;\n  color: #64748b;\n}\n\n.student-ai-search-btn {\n  border-radius: 12px;\n  padding: 12px 28px;\n  font-weight: 600;\n  font-size: 1rem;\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  border: none;\n  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.student-ai-search-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);\n}\n\n.student-ai-search-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.student-ai-error {\n  padding: 12px 16px;\n  border-radius: 12px;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n}\n\n.student-ai-response-card {\n  border: none;\n  border-radius: 20px;\n  box-shadow: 0 10px 40px rgba(99, 102, 241, 0.12);\n  overflow: hidden;\n  background: #fff;\n  animation: studentAiFadeIn 0.4s ease;\n}\n\n@keyframes studentAiFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(16px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.student-ai-response-card .card-body {\n  padding: 28px 32px;\n}\n\n.student-ai-response-title {\n  color: #3730a3;\n  font-weight: 700;\n  margin-bottom: 18px;\n  font-size: 1.15rem;\n}\n\n.student-ai-response-body {\n  color: #374151;\n  font-size: 1rem;\n  line-height: 1.65;\n}\n\n.student-ai-answer {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 18px 20px;\n  border-left: 4px solid #6366f1;\n}\n\n.student-ai-answer p {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.student-ai-pre {\n  margin: 0;\n  font-size: 0.9rem;\n  white-space: pre-wrap;\n  word-break: break-word;\n  background: transparent;\n  border: none;\n  padding: 0;\n}\n\n@media (max-width: 768px) {\n  .student-ai-form-card .card-body,\n  .student-ai-response-card .card-body {\n    padding: 20px 20px;\n  }\n\n  .student-ai-container {\n    padding-top: 16px;\n  }\n}\n\n/* ============================================\n   Student AI - Dark theme (AI Teacher style)\n   ============================================ */\n\n.student-ai-wrap.student-ai-dark {\n  display: flex;\n  min-height: 85vh;\n  height: 85vh;\n  background: #1a1b23;\n  color: #e2e8f0;\n  overflow: hidden;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.student-ai-wrap.student-ai-dark.student-ai-loading {\n  display: block;\n}\n\n.student-ai-wrap.student-ai-dark.student-ai-loading .loading-container.full-page {\n  min-height: 100%;\n  height: 100%;\n  width: 100%;\n  padding: 20px;\n}\n\n.student-ai-sidebar {\n  width: 280px;\n  min-width: 280px;\n  background: #16171f;\n  border-right: 1px solid #2d2e3a;\n  padding: 20px 16px;\n  display: flex;\n  flex-direction: column;\n}\n\n.student-ai-back {\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  font-size: 13px;\n  padding: 8px 0;\n  margin-bottom: 20px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  transition: color 0.2s;\n}\n\n.student-ai-back:hover {\n  color: #e2e8f0;\n}\n\n.student-ai-brand {\n  margin-bottom: 24px;\n}\n\n.student-ai-brand-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #38bdf8, #22d3ee);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n\n.student-ai-brand-icon i {\n  font-size: 24px;\n  color: #fff;\n}\n\n.student-ai-brand-title {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #f1f5f9;\n  margin: 0 0 4px 0;\n}\n\n.student-ai-brand-sub {\n  font-size: 0.7rem;\n  color: #64748b;\n  margin: 0;\n  letter-spacing: 0.08em;\n}\n\n.student-ai-new-btn {\n  width: 100%;\n  padding: 12px 16px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  border: none;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  color: #fff;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.2s, transform 0.2s;\n}\n\n.student-ai-new-btn:hover {\n  opacity: 0.95;\n  transform: translateY(-1px);\n  color: #fff;\n}\n\n.student-ai-recent {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.student-ai-recent-title {\n  font-size: 0.7rem;\n  color: #64748b;\n  margin: 0 0 12px 0;\n  letter-spacing: 0.08em;\n}\n\n.student-ai-recent-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  overflow-y: auto;\n}\n\n.student-ai-recent-empty {\n  font-size: 0.85rem;\n  color: #64748b;\n  padding: 8px 0;\n}\n\n.student-ai-recent-item {\n  font-size: 0.85rem;\n  color: #94a3b8;\n  padding: 10px 12px;\n  border-radius: 10px;\n  margin-bottom: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.student-ai-recent-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.student-ai-recent-item.is-active {\n  background: rgba(59, 130, 246, 0.22);\n  color: #dbeafe;\n}\n\n.student-ai-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.student-ai-top {\n  padding: 8px 16px;\n  background: #1a1b23;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.student-ai-top-card {\n  background: #111321;\n  border-radius: 14px;\n  border: 1px solid #2d2e3a;\n  padding: 10px 12px;\n}\n\n.student-ai-context-prompt {\n  font-size: 0.8rem;\n  color: #94a3b8;\n  margin: 0 0 14px 0;\n}\n\n.student-ai-dropdowns {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin: 0;\n}\n\n.student-ai-dropdown-group {\n  flex: 1;\n  min-width: 140px;\n}\n\n.student-ai-dropdown-group label {\n  display: block;\n  font-size: 0.7rem;\n  color: #64748b;\n  margin-bottom: 6px;\n  letter-spacing: 0.05em;\n}\n\n.student-ai-react-select {\n  width: 100%;\n}\n\n.student-ai-react-select .student-ai-select__control {\n  border-radius: 10px;\n  border: 1px solid #2d2e3a;\n  background: #25262f;\n  min-height: 40px;\n  box-shadow: none;\n}\n\n.student-ai-react-select .student-ai-select__control--is-focused {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.25);\n}\n\n.student-ai-react-select .student-ai-select__value-container {\n  padding: 4px 8px;\n  color: #e2e8f0;\n}\n\n.student-ai-react-select .student-ai-select__indicator-separator {\n  display: none;\n}\n\n.student-ai-react-select .student-ai-select__single-value {\n  color: #e2e8f0;\n  font-size: 0.9rem;\n}\n\n.student-ai-react-select .student-ai-select__placeholder {\n  color: #e2e8f0;\n  font-size: 0.9rem;\n}\n\n.student-ai-react-select .student-ai-select__input-container {\n  color: #ffffff;\n}\n\n/* Ensure typed search text inside react-select is white */\n.student-ai-react-select .student-ai-select__input input {\n  color: #ffffff;\n}\n\n.student-ai-react-select .student-ai-select__menu {\n  background: #181922;\n  border-radius: 10px;\n  border: 1px solid #2d2e3a;\n  z-index: 20;\n}\n\n.student-ai-react-select .student-ai-select__option {\n  font-size: 0.9rem;\n  padding: 8px 10px;\n  cursor: pointer;\n}\n\n.student-ai-react-select .student-ai-select__option--is-focused {\n  background: rgba(99, 102, 241, 0.2);\n}\n\n.student-ai-react-select .student-ai-select__option--is-selected {\n  background: #6366f1;\n  color: #fff;\n}\n\n.student-ai-image-group {\n  min-width: 180px;\n}\n\n.student-ai-top-image-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 42px;\n}\n\n.student-ai-top-image-btn {\n  flex: 1;\n  padding: 10px 14px;\n  border-radius: 10px;\n  border: 1px solid #2d2e3a;\n  background: #25262f;\n  color: #94a3b8;\n  font-size: 0.9rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: border-color 0.2s, color 0.2s;\n  margin: 0;\n}\n\n.student-ai-top-image-btn:hover {\n  border-color: #38bdf8;\n  color: #e2e8f0;\n}\n\n.student-ai-top-image-btn i {\n  font-size: 1.1rem;\n  color: #64748b;\n}\n\n.student-ai-top-image-btn span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 140px;\n}\n\n.student-ai-top-image-remove {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: 1px solid #2d2e3a;\n  background: #25262f;\n  color: #94a3b8;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  transition: color 0.2s, background 0.2s;\n}\n\n.student-ai-top-image-remove:hover {\n  color: #f87171;\n  background: rgba(248, 113, 113, 0.1);\n}\n\n.student-ai-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.student-ai-tag {\n  font-size: 0.8rem;\n  padding: 6px 12px;\n  border-radius: 8px;\n  background: #25262f;\n  color: #94a3b8;\n  border: 1px solid #2d2e3a;\n}\n\n.student-ai-content {\n  flex: 1;\n  padding: 28px 28px 24px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n.student-ai-welcome {\n  max-width: 480px;\n  margin: 0 auto;\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.student-ai-welcome-icon {\n  width: 88px;\n  height: 88px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, #38bdf8, #22d3ee);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 24px;\n}\n\n.student-ai-welcome-icon i {\n  font-size: 44px;\n  color: #fff;\n}\n\n.student-ai-welcome-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #f1f5f9;\n  margin: 0 0 12px 0;\n}\n\n.student-ai-welcome-desc {\n  font-size: 1rem;\n  color: #94a3b8;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.student-ai-chat {\n  margin-bottom: 20px;\n}\n\n.student-ai-msg {\n  max-width: 85%;\n  margin-bottom: 12px;\n}\n\n.student-ai-msg-user {\n  margin-left: auto;\n}\n\n.student-ai-msg-ai {\n  margin-right: auto;\n}\n\n.student-ai-msg-label {\n  font-size: 0.75rem;\n  color: #64748b;\n  margin-bottom: 4px;\n  display: block;\n}\n\n.student-ai-msg-label-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.student-ai-voice-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  border: 1px solid #3f4150;\n  background: #25262f;\n  color: #94a3b8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: color 0.2s, border-color 0.2s, transform 0.2s;\n}\n\n.student-ai-voice-btn:hover {\n  color: #38bdf8;\n  border-color: rgba(56, 189, 248, 0.5);\n  transform: translateY(-1px);\n}\n\n.student-ai-voice-btn.is-speaking {\n  color: #22d3ee;\n  border-color: #22d3ee;\n}\n\n.student-ai-msg-user .student-ai-msg-text {\n  background: #25262f;\n  border: 1px solid #2d2e3a;\n  color: #e2e8f0;\n  padding: 14px 18px;\n  border-radius: 14px 14px 14px 4px;\n  margin: 0;\n  line-height: 1.55;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.student-ai-msg-ai .student-ai-msg-text {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(139, 92, 246, 0.15));\n  border: 1px solid rgba(99, 102, 241, 0.3);\n  color: #e2e8f0;\n  padding: 0;\n  border-radius: 14px 14px 4px 14px;\n  margin: 0;\n}\n\n.student-ai-answer-box {\n  padding: 14px 18px;\n  line-height: 1.7;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.student-ai-answer-line {\n  margin: 0 0 6px 0;\n  font-size: 0.95rem;\n}\n\n.student-ai-answer-line:last-child {\n  margin-bottom: 0;\n}\n\n.student-ai-msg-typing .student-ai-dots {\n  display: flex;\n  gap: 6px;\n  padding: 14px 18px;\n}\n\n.student-ai-dots span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #64748b;\n  animation: studentAiBounce 1.4s ease-in-out infinite both;\n}\n\n.student-ai-dots span:nth-child(1) { animation-delay: 0s; }\n.student-ai-dots span:nth-child(2) { animation-delay: 0.2s; }\n.student-ai-dots span:nth-child(3) { animation-delay: 0.4s; }\n\n@keyframes studentAiBounce {\n  0%, 80%, 100% { transform: scale(0.6); opacity: 0.5; }\n  40% { transform: scale(1); opacity: 1; }\n}\n\n.student-ai-error-bar {\n  padding: 10px 28px;\n  background: rgba(239, 68, 68, 0.15);\n  color: #fca5a5;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: center;\n}\n\n.student-ai-input-bar {\n  padding: 16px 28px 24px;\n  border-top: 1px solid #2d2e3a;\n  background: #1a1b23;\n  position: sticky;\n  bottom: 0;\n  z-index: 10;\n}\n\n.student-ai-input-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #25262f;\n  border: 1px solid #2d2e3a;\n  border-radius: 14px;\n  padding: 8px 12px 8px 18px;\n  min-width: 0;\n}\n\n.student-ai-input-wrap.is-drag-over {\n  border-color: #38bdf8;\n  background: rgba(56, 189, 248, 0.08);\n}\n\n.student-ai-input {\n  flex: 1 1 0;\n  min-width: 0;\n  background: transparent;\n  border: none;\n  color: #e2e8f0;\n  font-size: 0.95rem;\n  padding: 10px 0;\n  outline: none;\n}\n\n.student-ai-input::placeholder {\n  color: #64748b;\n}\n\n.student-ai-file-hidden {\n  display: none;\n}\n\n.student-ai-attach-btn {\n  flex-shrink: 0;\n  padding: 8px 14px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #94a3b8;\n  cursor: pointer;\n  border: 1px dashed #3f4150;\n  transition: color 0.2s, background 0.2s, border-color 0.2s;\n}\n\n.student-ai-attach-btn:hover {\n  color: #38bdf8;\n  background: rgba(56, 189, 248, 0.1);\n  border-color: rgba(56, 189, 248, 0.4);\n}\n\n.student-ai-attach-btn i {\n  font-size: 1.2rem;\n}\n\n.student-ai-attach-label {\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.student-ai-send-btn {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  padding: 0;\n  border: none;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.2s, transform 0.2s;\n}\n\n.student-ai-send-btn:hover:not(:disabled) {\n  opacity: 0.95;\n  transform: scale(1.05);\n  color: #fff;\n}\n\n.student-ai-send-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.student-ai-send-btn i {\n  font-size: 1.25rem;\n}\n\n.student-ai-mic-btn {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  border: 1px solid #3f4150;\n  background: #1f2029;\n  color: #94a3b8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: color 0.2s, border-color 0.2s, background 0.2s, transform 0.2s;\n}\n\n.student-ai-mic-btn:hover {\n  color: #38bdf8;\n  border-color: rgba(56, 189, 248, 0.5);\n  transform: scale(1.03);\n}\n\n.student-ai-mic-btn.is-listening {\n  color: #22d3ee;\n  border-color: #22d3ee;\n  background: rgba(34, 211, 238, 0.12);\n  animation: studentAiMicPulse 1.1s ease-in-out infinite;\n}\n\n@keyframes studentAiMicPulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(34, 211, 238, 0.35); }\n  50% { box-shadow: 0 0 0 8px rgba(34, 211, 238, 0); }\n}\n\n.student-ai-file-hint-bar {\n  font-size: 0.8rem;\n  color: #94a3b8;\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.student-ai-file-remove {\n  margin-left: 10px;\n  background: none;\n  border: none;\n  color: #f87171;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.student-ai-file-remove:hover {\n  text-decoration: underline;\n}\n\n.student-ai-disclaimer {\n  font-size: 0.75rem;\n  color: #64748b;\n  margin: 10px 0 0 0;\n}\n\n/* Student AI - Tablet and below */\n@media (max-width: 768px) {\n  .student-ai-wrap.student-ai-dark {\n    flex-direction: column;\n    min-height: 100vh;\n    min-height: 100dvh;\n  }\n\n  .student-ai-sidebar {\n    width: 100%;\n    min-width: 100%;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 10px;\n    padding: 12px 14px;\n    border-bottom: 1px solid #2d2e3a;\n  }\n\n  .student-ai-back {\n    order: 0;\n    margin: 0;\n    padding: 8px 0;\n    min-height: 44px;\n    display: inline-flex;\n    align-items: center;\n  }\n\n  .student-ai-brand {\n    order: 1;\n    margin: 0 auto 0 0;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 0;\n  }\n\n  .student-ai-brand-icon {\n    width: 36px;\n    height: 36px;\n    margin: 0;\n  }\n\n  .student-ai-brand-icon i {\n    font-size: 18px;\n  }\n\n  .student-ai-brand-title {\n    font-size: 1.1rem;\n  }\n\n  .student-ai-new-btn {\n    order: 2;\n    width: auto;\n    margin: 0;\n    padding: 10px 16px;\n    font-size: 0.85rem;\n    min-height: 44px;\n  }\n\n  .student-ai-recent {\n    order: 3;\n    width: 100%;\n    max-height: 100px;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .student-ai-recent-title {\n    margin-bottom: 8px;\n  }\n\n  .student-ai-recent-item {\n    padding: 8px 10px;\n    font-size: 0.8rem;\n  }\n\n  .student-ai-top {\n    padding: 12px 14px;\n    flex-shrink: 0;\n  }\n\n  .student-ai-dropdowns {\n    gap: 12px;\n    flex-direction: column;\n  }\n\n  .student-ai-dropdown-group {\n    min-width: 100%;\n    width: 100%;\n  }\n\n  .student-ai-dropdown-group label {\n    font-size: 0.65rem;\n  }\n\n  .student-ai-select-dark {\n    padding: 12px 14px;\n    font-size: 1rem;\n    min-height: 48px;\n  }\n\n  .student-ai-image-group {\n    min-width: 100%;\n    width: 100%;\n  }\n\n  .student-ai-top-image-wrap {\n    min-height: 48px;\n  }\n\n  .student-ai-top-image-btn {\n    padding: 12px 14px;\n    font-size: 0.95rem;\n    min-height: 48px;\n  }\n\n  .student-ai-top-image-btn span {\n    max-width: 100%;\n  }\n\n  .student-ai-top-image-remove {\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n  }\n\n  .student-ai-content {\n    padding: 14px 14px 12px;\n    flex: 1;\n  }\n\n  .student-ai-welcome {\n    padding: 20px 12px;\n    max-width: 100%;\n  }\n\n  .student-ai-welcome-icon {\n    width: 72px;\n    height: 72px;\n    margin-bottom: 20px;\n  }\n\n  .student-ai-welcome-icon i {\n    font-size: 36px;\n  }\n\n  .student-ai-welcome-title {\n    font-size: 1.35rem;\n  }\n\n  .student-ai-welcome-desc {\n    font-size: 0.95rem;\n  }\n\n  .student-ai-msg {\n    max-width: 92%;\n  }\n\n  .student-ai-msg-user .student-ai-msg-text,\n  .student-ai-msg-ai .student-ai-msg-text {\n    padding: 12px 14px;\n    font-size: 0.95rem;\n  }\n\n  .student-ai-error-bar {\n    padding: 10px 14px;\n    font-size: 0.8rem;\n  }\n\n  .student-ai-input-bar {\n    padding: 12px 14px 20px;\n    padding-bottom: max(20px, env(safe-area-inset-bottom));\n    flex-shrink: 0;\n    overflow: hidden;\n  }\n\n  .student-ai-input-wrap {\n    padding: 8px 10px 8px 14px;\n    gap: 8px;\n    min-height: 52px;\n    min-width: 0;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .student-ai-input {\n    font-size: 16px;\n    min-height: 20px;\n  }\n\n  .student-ai-attach-btn {\n    padding: 10px 12px;\n    min-height: 44px;\n    flex-shrink: 0;\n  }\n\n  .student-ai-attach-label {\n    font-size: 0.8rem;\n  }\n\n  .student-ai-send-btn {\n    flex-shrink: 0;\n    width: 48px;\n    height: 48px;\n    min-width: 48px;\n    min-height: 48px;\n  }\n\n  .student-ai-mic-btn {\n    width: 48px;\n    height: 48px;\n    min-width: 48px;\n    min-height: 48px;\n  }\n\n  .student-ai-disclaimer {\n    font-size: 0.7rem;\n    margin-top: 8px;\n  }\n}\n\n/* Student AI - Small phones */\n@media (max-width: 480px) {\n  .student-ai-sidebar {\n    padding: 10px 12px;\n    gap: 8px;\n  }\n\n  .student-ai-brand-title {\n    font-size: 1rem;\n  }\n\n  .student-ai-brand-sub {\n    font-size: 0.65rem;\n  }\n\n  .student-ai-new-btn {\n    padding: 8px 12px;\n    font-size: 0.8rem;\n  }\n\n  .student-ai-recent {\n    max-height: 80px;\n  }\n\n  .student-ai-top {\n    padding: 10px 12px;\n  }\n\n  .student-ai-select-dark {\n    padding: 10px 12px;\n    min-height: 44px;\n  }\n\n  .student-ai-top-image-btn {\n    padding: 10px 12px;\n    min-height: 44px;\n  }\n\n  .student-ai-top-image-btn span {\n    font-size: 0.85rem;\n  }\n\n  .student-ai-content {\n    padding: 12px 12px 10px;\n  }\n\n  .student-ai-welcome {\n    padding: 16px 10px;\n  }\n\n  .student-ai-welcome-icon {\n    width: 64px;\n    height: 64px;\n    margin-bottom: 16px;\n  }\n\n  .student-ai-welcome-icon i {\n    font-size: 32px;\n  }\n\n  .student-ai-welcome-title {\n    font-size: 1.2rem;\n  }\n\n  .student-ai-welcome-desc {\n    font-size: 0.9rem;\n  }\n\n  .student-ai-input-bar {\n    padding: 10px 12px 16px;\n    padding-bottom: max(16px, env(safe-area-inset-bottom));\n  }\n\n  .student-ai-input-wrap {\n    padding: 6px 8px 6px 12px;\n    min-height: 48px;\n    min-width: 0;\n  }\n\n  .student-ai-attach-btn .student-ai-attach-label {\n    display: none;\n  }\n\n  .student-ai-attach-btn {\n    padding: 10px;\n    min-width: 44px;\n  }\n\n  .student-ai-send-btn {\n    flex-shrink: 0;\n    width: 44px;\n    height: 44px;\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  .student-ai-mic-btn {\n    width: 44px;\n    height: 44px;\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  .student-ai-msg-user .student-ai-msg-text,\n  .student-ai-msg-ai .student-ai-msg-text {\n    padding: 10px 12px;\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
